export default __webpack_public_path__ + "static/media/mercurial.654bf135.svg";